import { render, staticRenderFns } from "./TravelNotesInfo.vue?vue&type=template&id=447c6039&scoped=true"
import script from "./TravelNotesInfo.vue?vue&type=script&lang=js"
export * from "./TravelNotesInfo.vue?vue&type=script&lang=js"
import style0 from "./TravelNotesInfo.vue?vue&type=style&index=0&id=447c6039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c6039",
  null
  
)

export default component.exports